import React from "react";
import { observer } from "mobx-react-lite";
import { Col, Form, Row } from "react-bootstrap";
import type { ViewComponent } from "@frui.ts/views";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatAmount, translateEnum } from "utils/localizations";
import type PayGateRefundDetailViewModel from "viewModels/finance/refundApprovals/payGateRefunds/payGateRefundDetailViewModel";
import Section from "../../../common/section";
import FeeType from "entities/feeType";

const PayGateRefundSectionView: ViewComponent<PayGateRefundDetailViewModel> = observer(({ vm }) => {
  return (
    <Section title={vm.translate("refund.title")} context={vm.item}>
      <>
        <Row>
          <Form.Group as={Col} xl={6}>
            <Form.Label>{translateEnum("feeType", FeeType.ChargeRefundFee)}</Form.Label>
            <FakeInput target={vm} property="chargeRefundFee" valueFormatter={formatAmount} />
          </Form.Group>
          <Form.Group as={Col} xl={6}>
            <Form.Label>{vm.translate("bankFees")}</Form.Label>
            <FakeInput target={vm} property="bankFees" valueFormatter={formatAmount} />
          </Form.Group>
        </Row>
        <Row>
          <Form.Group as={Col} xs={6} className="mb-3">
            <Form.Label>{vm.translateModelAttribute("refund", "refundAmount")}</Form.Label>
            <FakeInput target={vm.item} property="refundAmount" valueFormatter={(amount: number) => formatAmount(amount)} />
          </Form.Group>
          <Form.Group as={Col} xs={6} className="mb-3">
            <Form.Label>{vm.translateModelAttribute("refund", "officialRecordId")}</Form.Label>
            <FakeInput target={vm.item} property="officialRecordId" />
          </Form.Group>
        </Row>
        <Row>
          <Form.Group as={Col} xs={12} className="mb-3">
            <Form.Label>{vm.translateModelAttribute("refund", "refundPaymentTemplateId")}</Form.Label>
            <FakeInput
              target={vm.item}
              property="refundPaymentTemplateId"
              valueFormatter={(refundPaymentTemplateId: string) => vm.translateRefundReason(refundPaymentTemplateId)}
            />
          </Form.Group>
        </Row>
      </>
    </Section>
  );
});

export default PayGateRefundSectionView;
